import { useState } from "react";
import jobCategories from '../../../data/Homepage/jobCategories.json'
import Mechanical from "../../../assets/HomePage/CoreIndustries/Mechanical.png";
import Embed from '../../../assets/Embed.png'
import MechanicalSvg from "../../../assets/HomePage/CoreIndustries/Mech.svg";
import EmbeddedSvg from "../../../assets/HomePage/CoreIndustries/Embedded.svg";
import ITSvg from "../../../assets/HomePage/CoreIndustries/It.svg";
import ExploreCategories from "../../../assets/HomePage/CoreIndustries/Explore All Categories.svg";
import It from '../../../assets/It.png'

export const CoreIndustries = () => {
    const [department, setDepartment] = useState("Mechanical");
    const [formDepartment, setFormDepartment] = useState(
        jobCategories["Mechanical"] || []
    );

    const handleAction = (value) => {
        if (value && jobCategories[value]) {
            setDepartment(value);
            setFormDepartment(jobCategories[value]);
        }
    };

    return (
        <section className="w-full bg-[#2c25c4] py-12 px-1 md:px-16 lg:px-24 xl:px-36">
            {/* Heading */}
            <h2 className="text-center text-2xl md:text-3xl text-white leading-snug">
                The <span className="font-bold">Core Industries</span> We Help You Succeed In
            </h2>
            <p className="text-gray-300 text-center text-base md:text-lg lg:text-xl mt-2">
                Mechanical • Electrical • IT – Turning Your Skills Into Careers
            </p>

            {/* Box Container */}
            <div className="w-full rounded-[20px] bg-[#edf4f4] mt-5 md:mt-10 lg:mt-10 px-3  md:px-8 lg:px-10 py-4 md:py-8 lg:py-8 flex flex-col items-center">
                {/* Department buttons */}
                <div className="flex flex-nowrap overflow-x-auto gap-4 bg-white rounded-lg px-1 py-1 md:px-2 md:py-2 justify-start">
                    <button
                        className={`w-full px-4 py-1 rounded-lg flex items-center justify-center gap-2 font-medium text-xs md:text-base
                        ${department === "Mechanical"
                                ? "bg-gradient-to-tr from-primary-300 to-secondary-200 text-white"
                                : "bg-transparent text-black"
                            }`}
                        onClick={() => handleAction("Mechanical")}
                    >
                        <img src={MechanicalSvg} alt="Mechanical" className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                        Mechanical
                    </button>
                    <button
                        className={`w-full px-4 py-1  rounded-lg flex items-center justify-center gap-2 font-medium text-sm md:text-base
                        ${department === "Embed"
                            ? "bg-gradient-to-br from-secondary-300 to-primary-300 text-white"
                                : "bg-transparent text-black"
                            }`}
                        onClick={() => handleAction("Embed")}
                    >
                        <img src={EmbeddedSvg} alt="Embedded" className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                        Embedded
                    </button>

                    <button
                        className={`w-full px-4 py-1 rounded-lg flex items-center justify-center gap-2 font-medium text-sm md:text-base
                        ${department === "IT"
                                ? "bg-gradient-to-tr from-primary-300 to-secondary-300 text-white"
                                : "bg-transparent text-black"
                            }`}
                        onClick={() => handleAction("IT")}
                    >
                        <img src={ITSvg} alt="IT" className=" w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                        IT
                    </button>
                </div>

                {/* Department List */}
                <div className=" mt-5 md:mt-10 lg:mt-10 flex flex-col lg:flex-row gap-8 w-full items-center lg:items-center">
                    <img
                        src={department === "Mechanical" ? Mechanical : department === "Embed" ? Embed : department === "IT" ? It : Mechanical }
                        alt="Department"
                        className="h-full max-h-[260px] aspect-square rounded-xl object-cover"
                    />
                    <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-4 h-fit ">
                        {formDepartment.map((dep, index) => (
                            <div key={index} className="flex text-center items-center justify-center bg-white rounded-lg shadow hover:shadow-md cursor-pointer transition text-gray-700 text-xs md:text-sm h-[40px] md:h-auto">
                                <p
                                    className="px-4 py-1 md:py-3 line-clamp-1 overflow-hidden whitespace-nowrap text-ellipsis"
                                >
                                    {dep}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Explore button */}
            <div onClick={() => window.location.href = '/explore'} className="w-[200px] md:w-[250px] bg-white text-[#2c25c4] flex justify-center items-center h-[44px] md:h-[48px] mt-10 rounded-[8px] mx-auto cursor-pointer hover:shadow-md transition">
                <p className="mr-2 text-sm md:text-base">Explore All Categories</p>
                <img
                    src={ExploreCategories}
                    alt="Explore All Categories"
                    className="w-4 h-4 md:w-5 md:h-5"
                />
            </div>
        </section>
    );
};



